export enum MedicalReportType {
    OPD = 1,
    IPD = 2,
    PastDocument = 3,
}
export const MedicalReportTypeLabels: Record<MedicalReportType, string> = {
    [MedicalReportType.OPD]: "OPD",
    [MedicalReportType.IPD]: "IPD",
    [MedicalReportType.PastDocument]: "Past Document",
};
